import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Card, CardContent, Typography, Box, useTheme, CircularProgress } from '@mui/material';
import { reportService } from '../../services/reportService';

export const RetentionWidget: React.FC = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<any[]>([]);
    const [stats, setStats] = useState<any>(null);

    useEffect(() => {
        const loadData = async () => {
            try {
                const retention = await reportService.getRetentionStats();
                setStats(retention);
                setData([
                    { name: 'New Customers', value: retention.newCount },
                    { name: 'Returning', value: retention.returningCount }
                ]);
            } catch (error) {
                console.error("Failed to load Retention data", error);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []);

    const COLORS = [theme.palette.primary.main, theme.palette.secondary.main];

    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom>
                    Customer Retention (30D)
                </Typography>
                
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                        <CircularProgress size={24} />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ width: '100%', height: 200 }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie
                                        data={data}
                                        cx="50%"
                                        cy="50%"
                                        innerRadius={60}
                                        outerRadius={80}
                                        paddingAngle={5}
                                        dataKey="value"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip
                                        contentStyle={{
                                            backgroundColor: theme.palette.background.paper,
                                            border: `1px solid ${theme.palette.divider}`
                                        }}
                                    />
                                    <Legend verticalAlign="bottom" height={36}/>
                                </PieChart>
                            </ResponsiveContainer>
                        </Box>
                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Typography variant="h4" fontWeight="bold" color="primary">
                                {stats?.ratio?.toFixed(1)}%
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Returning Customer Rate
                            </Typography>
                        </Box>
                    </>
                )}
            </CardContent>
        </Card>
    );
};
